import { action, thunk } from 'easy-peasy';
import AxiosWrapper from '../services/axios';

export default {
    //State
    authorization : "-",
    domain : "https://"+window.location.hostname,
    mainSettings: {
        BrandSettingsId: "",
        DateCreated: "",
        EngineId: "",
        Flow: "",
        HelperEngine: "",
        HelperMatrix: "",
        Id: "",
        Matrix: "",
        Message: "",
        ProductCode: "",
        ProductSettingsId: "",
        SettingsId: "",
        Status: "",
        Url: "",
        IsActive : true,
        AudioEye : null,
        RedirectTo : null
    },
    productSettings: {
        AppRef: "",
        ProductId: "",
        PrivacyUrl: "",
        FaqUrl: "",
        TermsUrl: "",
        OmpsUrl: "",
        ESignUrl: "",
        TrustpilotUrl: "",
        Features: [],
        BannerText: { Title: "", SubTitle: "", Description: [], Note: "" }
    },
    brandSettings: {
        ProductName: "",
        Primary: "",
        Secondary: "",
        Tertiary: "",
        Quarternary: "",
        CardImage: "",
        HeaderLogo: "",
        FooterLogo: "",
        BannerImage: "",
        BannerBgColor: "",
        FooterBgColor: "",
        CardImageNote: "",
        CustomerServiceNumber: "",
        BankName: ""
    },
    otherCardSettings: {
        AbandonFlag: null,
        AbandonURLRedirect: "",
        DeclineFlag: null,
        DeclineURLRedirect: "",
        ICommDeclineFlag: null,
        ICommDeclineOtherOfferUrl: "",
        ICommDeclineOtherOfferLclNoCheckingUrl: "",
        OtherOfferUrl: ""
    },
    webAssetsBaseUrlSettings: {
        StaticSite: "",
        Cdn: "",
        CdnImage: "",
        Continental: ""
    },

    validationRules: [],
    formFields: [],
    Pixels : {
     
    },
    isLoadingSettings: true,
    activateChecks: false,
    statesList: [],
    Session: "",
    CardColors : [],
    idList : "",
    pubCode : "",
    useRecaptcha : false,
    showOnDecline : true,
    invalidState : false,
    grandBankDeclined : false,
    showHeader : true,
    MainPath : "/",


    //Actions
    setShowHeader:                  action((state, payload) => { state.showHeader = payload }),
    setDomain:                      action((state, payload) => { state.domain = payload }),
    setIsLoadingSettings:           action((state, payload) => { state.isLoadingSettings = payload }),
    setMainSettings:                action((state, payload) => { state.mainSettings = {...state.mainSettings, ...payload} }),
    setValidationRules:             action((state, payload) => { state.validationRules = payload }),
    setProductSettings:             action((state, payload) => { state.productSettings = payload }),
    setBrandSettings:               action((state, payload) => { state.brandSettings = payload }),
    setStatesList:                  action((state, payload) => { state.statesList = payload }),
    setPixels:                      action((state, payload) => { state.Pixels = payload }),
    setAuthorization:               action((state, payload) => { state.authorization = payload }),
    setSession:                     action((state, payload) => { state.Session = payload }),
    setAppRef:                      action((state, payload) => { state.productSettings.AppRef = payload }),
    setCardColor:                   action((state, payload) => { state.CardColors = payload }),
    setOtherCardSettings:           action((state, payload) => { state.otherCardSettings = payload }),
    setWebAssetsBaseUrlSettings:    action((state, payload) => { state.webAssetsBaseUrlSettings = payload }),
    setUseRecaptcha:                action((state, payload) => { state.useRecaptcha = payload }),
    setIdList:                      action((state, payload) => { state.idList = payload }),
    setPubCode:                     action((state, payload) => { state.pubCode = payload }),
    setShowOnDeclined:              action((state, payload) => { state.showOnDecline = payload }),
    setInvalidState:                action((state, payload) => { state.invalidState = payload }),
    setGrandBanckDeclined:          action((state, payload) => { state.grandBankDeclined = payload }),
    setFormFields:                  action((state, payload) => { state.formFields = payload }),
    setMainPath:                    action((state, payload) => { state.MainPath = payload }),
    //Primary Conf
    getSiteSettings: thunk(async (actions, payload) => {
        const api = new AxiosWrapper();
        let domain = "https://" + window.location.host + ((window.location.pathname.split("/")[1] === '') ? '' : "/" + window.location.pathname.split("/")[1]) ;
        //domain = "https://devprequal3.yourreflexcard.com"; // hardcode url for testing ex: "https://newdmtest-yourceruleancard.contfinco.net/"
      
        let data = await api.post('get-configuration', { 
            url: domain,
            environment: process.env.REACT_APP_CFC_APPLICANT_BUILDENV, 
            form: "home", 
            pubId: (api.findParam("pub") || api.findParam("pubid")) || "",
            token: api.findParam("token") || ""
        },true);

        //second try

        if(!data || data.Success === false){ 
            domain = "https://" + window.location.host;

            data = await api.post('get-configuration', { 
                url: domain,
                environment: process.env.REACT_APP_CFC_APPLICANT_BUILDENV, 
                form: "home", 
                pubId: (api.findParam("pub") || api.findParam("pubid")) || "",
                token: api.findParam("token") || ""
            },true);
         }

        if(!data || data.Success === false){ return false }


        actions.setDomain(domain);
        data = data.Payload;

        if(typeof data.MainSettings.RedirectTo !== "undefined" && data.MainSettings.RedirectTo !== null){ window.location.replace(data.MainSettings.RedirectTo + window.location.search); return "redirection"; }

        sessionStorage.setItem("sessionToken", data.Token);
        localStorage.setItem("sessionToken", data.Token);
        sessionStorage.setItem("oldSessionToken", data.Session);
        
        sessionStorage.setItem("defaultTrafficSource", (api.findParam("pub") || api.findParam("pubid"))? data.ProductSettings.TrafficSource : "Organic");
        sessionStorage.setItem("ProductId", data.ProductSettings.ProductId || "");
        sessionStorage.setItem("ReportId", data.SessionReportId || "0");
        //data.MainSettings.ProductCode = "0352";
        data.MainSettings.Flow = api.findParam("useFlow") || data.MainSettings.Flow;
        actions.setMainSettings(data.MainSettings);
       
        actions.setBrandSettings(data.BrandSettings);
        actions.setProductSettings(data.ProductSettings);
        actions.setAppRef(data.ProductSettings.ApplicationSourceReference);
        actions.setValidationRules(data.ValidationRules || []);
        if(typeof data.FormFields == "undefined"){data.FormFields = []}
      
        actions.setUseRecaptcha(data.FormFields.find(field => field.fieldName.toUpperCase() === "CAPTCHA" && field.isActive === true) || false);
        actions.setFormFields(data.FormFields || []);
        actions.setStatesList(data.StatesList || []);
        data.Pixels = data.Pixels || [];
        actions.setPixels(data.Pixels || []);
        actions.setSession(data.Session);
        actions.setIsLoadingSettings(false);
        actions.setOtherCardSettings(data.OtherCardSettings);
        actions.setWebAssetsBaseUrlSettings(data.WebAssetsBaseUrlSettings);
        return data;
    })
}